import { ccLandingConfig } from "./cclanding-config";
import { autotraderConfig } from "./autotrader-config";
import type { Systems, environments } from "./types";

export const getEnviromentConfig = (url?: string) => {
  const urlToUse = url || window.location.href;
  const system = deriveSystemName(urlToUse);
  switch (system) {
    case "dealerCenterDDC":
      return ccLandingConfig[deriveEnvironmentName(urlToUse)];
    case "dealerCenterAT":
      return autotraderConfig[deriveEnvironmentName(urlToUse)];
    default:
      throw new Error("System not found");
  }
};

export const deriveSystemName = (url?: string): Systems => {
  const urlToUse = url || window.location.href;
  if (urlToUse.includes("/autotrader")) return "dealerCenterAT";
  if (urlToUse.includes("dealer.com")) return "dealerCenterDDC";
  return "dealerCenterDDC";
};
export const deriveEnvironmentName = (url?: string): environments => {
  const urlToUse = url || window.location.href;
  if (
    urlToUse.startsWith("http://localhost") ||
    urlToUse.startsWith("localhost")
  ) {
    return "local";
  } else if (
    urlToUse.startsWith("https://apps.dealercenter-np.coxautoinc.com") ||
    urlToUse.startsWith("apps.dealercenter-np.coxautoinc.com") ||
    urlToUse.startsWith("https://apps.dealercenter-np.coxautoinc.com") ||
    urlToUse.startsWith("apps.dealercenter-np.coxautoinc.com")
  ) {
    return "qa";
  } else if (
    urlToUse.startsWith("https://apps.dealercenter.coxautoinc.com") ||
    urlToUse.startsWith("apps.dealercenter.coxautoinc.com") ||
    urlToUse.startsWith("https://apps.dealercenter.coxautoinc.com") ||
    urlToUse.startsWith("apps.dealercenter.coxautoinc.com")
  ) {
    return "prod";
  } else {
    return "local";
  }
};
